import { http } from './config'

export default {
  listandoEstado:() => {
    return http.get('estado.php')
  }
}